module.exports = __webpack_public_path__ + "img/culture.8f1cb4bc.png";